export const API_URL = "https://pixit.juliesouchet.online:8000";
// export const API_URL = "http://127.0.0.1:8000";
